const burgerButton = document.querySelector('.header-burger-button');
const burgerIcon = document.querySelector('.header-burger');
const crossIcon = document.querySelector('.header-cross');
const mobileMenu = document.querySelector('.mobile-menu');
const body = document.querySelector('body');
const mobileLinks = document.querySelectorAll('.mobile-nav--link');

burgerButton.addEventListener('click', habdleMobileMenu);

mobileLinks.forEach(link => link.addEventListener('click', habdleMobileMenu));

function habdleMobileMenu() {
  if (burgerIcon.classList.contains('active')) {
    burgerIcon.classList.remove('active');
    crossIcon.classList.add('active');
    body.style.overflow = 'hidden';
    mobileMenu.style.display = 'flex';
  } else {
    crossIcon.classList.remove('active');
    burgerIcon.classList.add('active');
    body.style.overflow = 'auto';
    mobileMenu.style.display = 'none';
  }
}

const checkScreenWidth = () => {
  if (window.innerWidth > 1200) {
    crossIcon.classList.remove('active');
    burgerIcon.classList.add('active');
    body.style.overflow = 'auto';
    mobileMenu.style.display = 'none';
  }
};

checkScreenWidth();

window.addEventListener('resize', checkScreenWidth);
